import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import SubjectPropertyInput from './SubjectPropertyInput'
import InvestorList from './InvestorList'
import CashBuyersMap from './CashBuyersMap'
import {
  searchCashBuyers,
  selectInvestor,
  setSortBy,
  setRadius,
  setTake,
  setClassifications,
  setPropertyTypes,
  setSubjectProperty,
  toggleInvestorChecked,
} from 'data/cashbuyers/actions'
import {
  getSubjectProperty,
  getRadius,
  getTake,
  getInvestors,
  getSelectedInvestorId,
  getSortBy,
  getLoading,
  getError,
  getProperties,
  getClassifications,
  getPropertyTypes,
  getSubjectCoords,
  getCheckedInvestorIds,
} from 'data/cashbuyers/selectors'
import css from './style.scss'

export default function CashBuyers() {
  const dispatch = useDispatch()
  const subjectProperty = useSelector(getSubjectProperty)
  const radius = useSelector(getRadius)
  const take = useSelector(getTake)
  const investors = useSelector(getInvestors)
  const selectedInvestorId = useSelector(getSelectedInvestorId)
  const sortBy = useSelector(getSortBy)
  const loading = useSelector(getLoading)
  const error = useSelector(getError)
  const properties = useSelector(getProperties)
  const classifications = useSelector(getClassifications)
  const subjectCoords = useSelector(getSubjectCoords)
  const checkedInvestorIds = useSelector(getCheckedInvestorIds)
  const propertyTypes = useSelector(getPropertyTypes)

  const handleSearch = () => {
    if (!subjectProperty) return
    const address = subjectProperty.get('label') || subjectProperty.get('address')
    dispatch(searchCashBuyers(address, radius, take, classifications, propertyTypes))
  }

  const handleSelectInvestor = (id) => dispatch(selectInvestor(id))
  const handleSort = (newSort) => dispatch(setSortBy(newSort))
  const handleRadiusChange = (newRadius) => dispatch(setRadius(newRadius))
  const handleClassificationsChange = (val) => dispatch(setClassifications(val))
  const handlePropertyTypesChange = (val) => dispatch(setPropertyTypes(val))
  const handleToggleChecked = (id) => dispatch(toggleInvestorChecked(id))
  const handleTakeChange = (newTake) => dispatch(setTake(newTake))
  const handleSubjectChange = (suggestion) => dispatch(setSubjectProperty(suggestion))

  const investorsList = investors?.toJS?.() || []
  const propertiesList = properties?.toJS?.() || []

  return (
    <div className={css.cashBuyersPage}>
      <div className={css.leftPanel}>
        <SubjectPropertyInput
          subjectProperty={subjectProperty}
          radius={radius}
          classifications={classifications}
          propertyTypes={propertyTypes}
          loading={loading}
          onSubjectChange={handleSubjectChange}
          onRadiusChange={handleRadiusChange}
          onClassificationsChange={handleClassificationsChange}
          onPropertyTypesChange={handlePropertyTypesChange}
          onSearch={handleSearch}
        />

        {error && (
          <div className={css.errorMessage}>{error}</div>
        )}

        {investorsList.length > 0 && (
          <div className={css.aiSummary}>
            <div className={css.aiSummaryTitle}>AI ANALYSIS SUMMARY</div>
            <div className={css.aiSummaryText}>
              Found {investorsList.length} active cash buyers within {radius} mile{radius !== 1 ? 's' : ''}.
              {' '}Top matches show strong investment patterns aligned with your property.
            </div>
          </div>
        )}

        <InvestorList
          investors={investorsList}
          selectedInvestorId={selectedInvestorId}
          checkedInvestorIds={checkedInvestorIds}
          sortBy={sortBy}
          loading={loading}
          onSelectInvestor={handleSelectInvestor}
          onToggleChecked={handleToggleChecked}
          onSort={handleSort}
        />
      </div>

      <div className={css.rightPanel}>
        <CashBuyersMap
          subjectProperty={subjectCoords?.toJS?.() || subjectProperty?.toJS?.()}
          investors={investorsList}
          properties={propertiesList}
          radius={radius}
          selectedInvestorId={selectedInvestorId}
          checkedInvestorIds={checkedInvestorIds}
          onSelectInvestor={handleSelectInvestor}
        />
      </div>
    </div>
  )
}
